import React, { Component } from 'react';
import { Input } from '@progress/kendo-react-inputs';
import Modal from '../general/Modal';
import { getAuthToken, handleAuthTokenError, BASEURI, advancedFilter } from '../utils';
import { RefreshPortal } from '../general/Layout';
import RefreshButton from '../general/RefreshButton';
import StationDetails from './StationDetails';
import StationCard from './StationCard';
import ModalForm from './ModalForm';
import DraginoSetupDialog from './DraginoSetupDialog';


class Stations extends Component {
  constructor(props) {
    super(props);

    this.state = {
      wiseconnStations: [],
      loadingDevices: false,
      davisAccounts: [],
      qampoAccounts: [],
      weenatAccounts: [],
      prismabAccounts: [],
      agroopAccounts: [],
      stations: [],
      searchInput: '',
      showDialog: false,
      viewedStation: null,
      viewStation: false,
      stationData: [],
      loading: false,
      downloading: false,
      addingDevice: false,
      error: '',
      renaming: false,
      notInitial: false,
      draginoModels: [],
      draginoSetup: null,
      regenerating: false,
    }

    this.addStation = this.addStation.bind(this);
    this.addDraginoStation = this.addDraginoStation.bind(this);
    this.regenerateDraginoCredentials = this.regenerateDraginoCredentials.bind(this);
    this.loadDraginoModels = this.loadDraginoModels.bind(this);
    this.openDialog = this.openDialog.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.loadStations = this.loadStations.bind(this);
    this.viewStation = this.viewStation.bind(this);
    this.download = this.download.bind(this);
    this.removeStation = this.removeStation.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.rename = this.rename.bind(this);
    this.filterStations = this.filterStations.bind(this);
    this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
    this.handleStationDetailChange = this.handleStationDetailChange.bind(this);
    this.submit = this.submit.bind(this);
    this.addDavisAccount = this.addDavisAccount.bind(this);
    this.loadLinkedDavisAccounts = this.loadLinkedDavisAccounts.bind(this);
    this.deleteDavisAccount = this.deleteDavisAccount.bind(this);
    this.addQampoAccount = this.addQampoAccount.bind(this);
    this.loadLinkedQampoAccounts = this.loadLinkedQampoAccounts.bind(this);
    this.deleteQampoAccount = this.deleteQampoAccount.bind(this);
    this.addWeenatAccount = this.addWeenatAccount.bind(this);
    this.loadLinkedWeenatAccounts = this.loadLinkedWeenatAccounts.bind(this);
    this.deleteWeenatAccount = this.deleteWeenatAccount.bind(this);
    this.addPrismabAccount = this.addPrismabAccount.bind(this);
    this.loadLinkedPrismabAccounts = this.loadLinkedPrismabAccounts.bind(this);
    this.deletePrismabAccount = this.deletePrismabAccount.bind(this);
    this.addAgroopAccount = this.addAgroopAccount.bind(this);
    this.loadLinkedAgroopAccounts = this.loadLinkedAgroopAccounts.bind(this);
    this.deleteAgroopAccount = this.deleteAgroopAccount.bind(this);
  }

  componentDidMount() {

    this.loadStations();
    this.loadDraginoModels();
    this.loadLinkedDavisAccounts();
    this.loadLinkedQampoAccounts();
    this.loadLinkedWeenatAccounts();
    this.loadLinkedPrismabAccounts();
    this.loadLinkedAgroopAccounts();

    // document.getElementById('refresh').addEventListener('click', this.refresh);

    // Refresh list of stations every 30 seconds
    this.setState({
      interval: setInterval(this.refresh, 30 * 1000)
    });

  }

  componentWillUnmount() {
    // document.getElementById('refresh').removeEventListener('click', this.refresh);
    clearInterval(this.state.interval);
  }

  refresh = () => {
    this.loadStations();
    if (this.state.viewStation)
      this.viewStation(this.state.viewedStation.serial);
  }

  loadStations() {
    if (this.state.notInitial) {
      this.setState({ loading: true });
    }
    let url = `${BASEURI}/api/stations/`,
      options = {
        method: 'GET',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ loading: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            return response.json();
          })
          .then((stations) => {
            const normalizedStations = Array.isArray(stations) ? stations : [];

            if (!this.state.notInitial) {
              this.setState({ notInitial: true });
            }
            this.setState({
              loading: false,
              stations: normalizedStations,
            });
          })
          .catch(error => console.error('Error:', error));

      });
  }

  openDialog() {
    this.setState({
      showDialog: true
    });
  }

  closeDialog() {
    this.setState({
      showDialog: false,
      error: '',
      addingDevice: false,
    });
  }

  loadLinkedDavisAccounts() {

    let url = `${BASEURI}/api/dashboard/davis/account/`,
      options = {
        method: 'GET',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ loading: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            if (response.status !== 200 && response.status !== 201) {
              response.text().then(text => this.setState({ 'error': text }));
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then((accounts) => {
            this.setState({ davisAccounts: accounts })
          })
          .catch(error => {
            console.log(error);
          });

      });

  }

  loadLinkedQampoAccounts() {
    let url = `${BASEURI}/api/dashboard/qampo/account/`,
      options = {
        method: 'GET',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ loading: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            if (response.status !== 200 && response.status !== 201) {
              response.text().then(text => this.setState({ 'error': text }));
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then((accounts) => {
            this.setState({ qampoAccounts: accounts })
          })
          .catch(error => {
            console.log(error);
          });

      });

  }

  deleteDavisAccount(id, name) {
    if (!window.confirm(
      this.props.intl.formatMessage(
        {
          id: 'app.stations.modelFrom.davis.accountDeleteMessage',
          defaultMessage: '[{name}] stations will not be able to sync their data. \n Are you sure want to delete it?'
        },
        { name: name })))
      return

    let url = `${BASEURI}/api/dashboard/davis/account/${id}/`,
      options = {
        method: 'DELETE',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ loading: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            if (response.status !== 200 && response.status !== 201) {
              response.text().then(text => this.setState({ 'error': text }));
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then((accounts) => {
            this.loadLinkedDavisAccounts();
          })
          .catch(error => {
            console.log(error);
          });

      });

  }

  deleteQampoAccount(id, name) {
    if (!window.confirm(
      this.props.intl.formatMessage(
        {
          id: 'app.stations.modelFrom.davis.accountDeleteMessage',
          defaultMessage: '[{name}] stations will not be able to sync their data. \n Are you sure want to delete it?'
        },
        { name: name })))
      return

    let url = `${BASEURI}/api/dashboard/qampo/account/${id}/`,
      options = {
        method: 'DELETE',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ loading: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            if (response.status !== 200 && response.status !== 201) {
              response.text().then(text => this.setState({ 'error': text }));
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then((accounts) => {
            this.loadLinkedQampoAccounts();
          })
          .catch(error => {
            console.log(error);
          });

      });

  }


  addDavisAccount(account) {

    this.setState({ error: '', addingDevice: true });

    let url = `${BASEURI}/api/dashboard/davis/account/`,
      options = {
        method: 'POST',
        body: JSON.stringify(account),
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ addingDevice: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            if (response.status !== 200 && response.status !== 201) {
              response.text().then(text => this.setState({ 'error': text, addingDevice: false }));
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then((message) => {
            console.log(message)
            this.setState({ addingDevice: false });
            this.loadLinkedDavisAccounts()
            this.loadStations();
            this.closeDialog();

          })
          .catch(error => {
            console.log(error);
            this.setState({ addingDevice: false });
          });

      });

  }

  loadLinkedWeenatAccounts() {
    let url = `${BASEURI}/api/dashboard/weenat/account/`,
      options = {
        method: 'GET',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ loading: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            if (response.status !== 200 && response.status !== 201) {
              response.text().then(text => this.setState({ 'error': text }));
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then((accounts) => {
            this.setState({ weenatAccounts: accounts })
          })
          .catch(error => {
            console.log(error);
          });

      });

  }

  deleteWeenatAccount(id, name) {
    if (!window.confirm(
      this.props.intl.formatMessage(
        {
          id: 'app.stations.modelFrom.davis.accountDeleteMessage',
          defaultMessage: '[{name}] stations will not be able to sync their data. \n Are you sure want to delete it?'
        },
        { name: name })))
      return

    let url = `${BASEURI}/api/dashboard/weenat/account/${id}/`,
      options = {
        method: 'DELETE',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ loading: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            if (response.status !== 200 && response.status !== 201) {
              response.text().then(text => this.setState({ 'error': text }));
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then(() => {
            this.loadLinkedWeenatAccounts();
          })
          .catch(error => {
            console.log(error);
          });

      });

  }

  addWeenatAccount(account) {

    this.setState({ error: '', addingDevice: true });

    let url = `${BASEURI}/api/dashboard/weenat/account/`,
      options = {
        method: 'POST',
        body: JSON.stringify({ name: account.name, api_key: account.api_key }),
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ addingDevice: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            if (response.status !== 200 && response.status !== 201) {
              response.text().then(text => this.setState({ 'error': text, addingDevice: false }));
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then((message) => {
            console.log(message)
            this.setState({ addingDevice: false });
            this.loadLinkedWeenatAccounts()
            this.loadStations();
            this.closeDialog();

          })
          .catch(error => {
            console.log(error);
            this.setState({ addingDevice: false });
          });

      });

  }

  loadLinkedPrismabAccounts() {
    let url = `${BASEURI}/api/dashboard/prismab/account/`,
      options = {
        method: 'GET',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ loading: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            if (response.status !== 200 && response.status !== 201) {
              response.text().then(text => this.setState({ 'error': text }));
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then((accounts) => {
            this.setState({ prismabAccounts: accounts })
          })
          .catch(error => {
            console.log(error);
          });

      });

  }

  deletePrismabAccount(id, name) {
    if (!window.confirm(
      this.props.intl.formatMessage(
        {
          id: 'app.stations.modelFrom.davis.accountDeleteMessage',
          defaultMessage: '[{name}] stations will not be able to sync their data. \n Are you sure want to delete it?'
        },
        { name: name })))
      return

    let url = `${BASEURI}/api/dashboard/prismab/account/${id}/`,
      options = {
        method: 'DELETE',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ loading: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            if (response.status !== 200 && response.status !== 201) {
              response.text().then(text => this.setState({ 'error': text }));
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then(() => {
            this.loadLinkedPrismabAccounts();
          })
          .catch(error => {
            console.log(error);
          });

      });

  }

  addPrismabAccount(account) {

    this.setState({ error: '', addingDevice: true });

    let url = `${BASEURI}/api/dashboard/prismab/account/`,
      options = {
        method: 'POST',
        body: JSON.stringify({ email: account.email, password: account.password }),
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ addingDevice: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            if (response.status !== 200 && response.status !== 201) {
              response.text().then(text => this.setState({ 'error': text, addingDevice: false }));
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then((message) => {
            console.log(message)
            this.setState({ addingDevice: false });
            this.loadLinkedPrismabAccounts()
            this.loadStations();
            this.closeDialog();

          })
          .catch(error => {
            console.log(error);
            this.setState({ addingDevice: false });
          });

      });

  }

  loadLinkedAgroopAccounts() {
    let url = `${BASEURI}/api/dashboard/agroop/account/`,
      options = {
        method: 'GET',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ loading: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            if (response.status !== 200 && response.status !== 201) {
              response.text().then(text => this.setState({ 'error': text }));
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then((accounts) => {
            this.setState({ agroopAccounts: accounts })
          })
          .catch(error => {
            console.log(error);
          });

      });

  }

  deleteAgroopAccount(id, name) {
    if (!window.confirm(
      this.props.intl.formatMessage(
        {
          id: 'app.stations.modelFrom.davis.accountDeleteMessage',
          defaultMessage: '[{name}] stations will not be able to sync their data. \n Are you sure want to delete it?'
        },
        { name: name })))
      return

    let url = `${BASEURI}/api/dashboard/agroop/account/${id}/`,
      options = {
        method: 'DELETE',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ loading: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            if (response.status !== 200 && response.status !== 201) {
              response.text().then(text => this.setState({ 'error': text }));
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then(() => {
            this.loadLinkedAgroopAccounts();
          })
          .catch(error => {
            console.log(error);
          });

      });

  }

  addAgroopAccount(account) {

    this.setState({ error: '', addingDevice: true });

    let url = `${BASEURI}/api/dashboard/agroop/account/`,
      options = {
        method: 'POST',
        body: JSON.stringify({ name: account.name, api_key: account.api_key }),
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ addingDevice: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            if (response.status !== 200 && response.status !== 201) {
              response.text().then(text => this.setState({ 'error': text, addingDevice: false }));
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then((message) => {
            console.log(message)
            this.setState({ addingDevice: false });
            this.loadLinkedAgroopAccounts()
            this.loadStations();
            this.closeDialog();

          })
          .catch(error => {
            console.log(error);
            this.setState({ addingDevice: false });
          });

      });

  }

  addQampoAccount(account) {

    this.setState({ error: '', addingDevice: true });

    let url = `${BASEURI}/api/dashboard/qampo/account/`,
      options = {
        method: 'POST',
        body: JSON.stringify(account),
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ addingDevice: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            if (response.status !== 200 && response.status !== 201) {
              response.text().then(text => this.setState({ 'error': text, addingDevice: false }));
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then((message) => {
            console.log(message)
            this.setState({ addingDevice: false });
            this.loadLinkedQampoAccounts()
            this.loadStations();
            this.closeDialog();

          })
          .catch(error => {
            console.log(error);
            this.setState({ addingDevice: false });
          });

      });

  }


  loadDraginoModels() {
    let url = `${BASEURI}/api/v2/dragino/models/`,
      options = { method: 'GET', headers: {} };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) return false;
        options.headers.Authorization = `Bearer  ${token}`;
        fetch(url, options)
          .then(response => response.ok ? response.json() : [])
          .then(models => this.setState({ draginoModels: Array.isArray(models) ? models : [] }))
          .catch(error => console.log('Error:', error));
      });
  }

  addDraginoStation(station) {
    const imei = (station.serial || '').trim();
    const model = station.model && station.model.model ? station.model.model : station.model;

    if (!/^\d{15}$/.test(imei)) {
      this.setState({ error: 'The IMEI must be 15 digits' });
      return;
    }
    if (!model) {
      this.setState({ error: 'Select the node model' });
      return;
    }

    this.setState({ error: '', addingDevice: true });

    let url = `${BASEURI}/api/v2/dragino/devices/`,
      options = {
        method: 'POST',
        body: JSON.stringify({ imei, model, name: station.name || '', site: station.site || '' }),
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ addingDevice: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            if (response.status !== 201) {
              response.json()
                .then(body => this.setState({ error: body.detail || JSON.stringify(body), addingDevice: false }))
                .catch(() => this.setState({ error: response.statusText, addingDevice: false }));
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then((result) => {
            this.setState((state, props) => {
              let prev_stations = Array.isArray(state.stations) ? state.stations.slice() : [];
              prev_stations.push(result.station);
              return { stations: prev_stations, addingDevice: false, draginoSetup: result };
            });
            this.closeDialog();
          })
          .catch(error => console.log('Error:', error));
      });
  }

  regenerateDraginoCredentials(serial) {
    this.setState({ regenerating: true, error: '' });

    let url = `${BASEURI}/api/v2/dragino/devices/${serial}/regenerate/`,
      options = {
        method: 'POST',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ regenerating: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            if (!response.ok) {
              response.json()
                .then(body => this.setState({ error: body.detail || response.statusText, regenerating: false }))
                .catch(() => this.setState({ error: response.statusText, regenerating: false }));
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then((result) => this.setState({ regenerating: false, draginoSetup: result }))
          .catch(error => console.log('Error:', error));
      });
  }

  addStation(station) {
    //validate station serial/password format before adding
    let serialRegex, passRegex;
    if (station.api === 'Fieldclimate') {
      serialRegex = /^[A-Z0-9]{8}$/;
      passRegex = /^[A-Za-z0-9]{5}$/;
    } else if (station.api === 'Ech2o') {
      serialRegex = /^[A-Z0-9]{8}$/;
      passRegex = /^[a-z0-9]{4,5}-[a-z0-9]{4,5}$/;
    } else if (station.api === 'Zentra') { //Zentra api
      serialRegex = /[z,0]6-\d{5}$|[A,0-9]\d{7}$/;
      passRegex = /^\d{5}-\d{5}$/;
    } else {
      serialRegex = /[A-Za-z0-9]/;
      passRegex = serialRegex;
    }

    if (['Agronic', 'E-Smart', 'Talgil', 'Galcon', 'Ag-Zoom'].indexOf(station.api) === -1)
      if (!serialRegex.test(station.serial) || !passRegex.test(station.password)) {
        this.setState({ error: `Inconsistent serial or password format for ${station.api} API` })
        return;
      }

    this.setState({ error: '', addingDevice: true });

    let url = `${BASEURI}/api/stations/`,
      options = {
        method: 'POST',
        body: JSON.stringify(station),
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ addingDevice: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            if (response.status !== 200 && response.status !== 201) {
              response.text().then(text => this.setState({ 'error': text, addingDevice: false }));
              throw new Error(response.statusText);
            }
            return response.json();
          })
          .then((stations) => {
            this.setState((state, props) => {
              let prev_stations = Array.isArray(state.stations) ? state.stations.slice() : [];
              prev_stations.push(stations);
              return { stations: prev_stations, addingDevice: false };
            });

            if (!station.keepOpen)
              this.closeDialog();

            // Call onSuccess callback if provided
            if (station.onSuccess) {
              station.onSuccess();
            }
          })
          .catch(error => {
            console.log(error);
            this.setState({ addingDevice: false });
          });

      });

  }

  viewStation(serial) {
    const stationsList = Array.isArray(this.state.stations) ? this.state.stations : [];

    for (let i = 0; i < stationsList.length; i++) {
      let station = stationsList[i];
      if (station.serial === serial)
        this.setState({
          'viewedStation': station,
          'viewStation': true,
          'stationData': station.ranges
        })
    }

    let url = `${BASEURI}/api/stations/${serial}/`,
      options = {
        method: 'GET',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            return response.json();
          })
          .then((station) => {
            let allStations = Array.isArray(this.state.stations) ? this.state.stations.slice() : [];

            for (let i in allStations) {
              if (station.serial === serial) {
                this.setState({
                  'stationData': station.ranges,
                  viewedStation: station
                });
                break;
              }
            }

            // this.setState({
            //   stations: stations,
            // });
          })
          .catch(error => console.error('Error:', error));

      });

  }


  download(params) {

    // let data = {
    //   start: formatDate
    // }

    this.setState({ downloading: true });

    let url = `${BASEURI}/api/stations/download/`,
      options = {
        method: 'POST',
        body: JSON.stringify(params),
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ downloading: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {
            if (!response.ok) {
              response.text().then(err => console.log(err));
              throw new Error(response.statusText, response.status);
            }
            return response.json()
          })
          .then((changedStation) => {
            let stations = Array.isArray(this.state.stations) ? this.state.stations.slice() : [];
            let index = stations.findIndex(s => s.serial === changedStation.serial);
            if (index === -1) {
              stations.push(changedStation);
            } else {
              stations.splice(index, 1, changedStation);
            }
            this.setState({ stations: stations, downloading: false });
            this.viewStation(params.device);
          })
          .catch(error => console.log('Error:', error));

      });
  }

  removeStation(serial) {

    this.setState({ loading: true });

    let url = `${BASEURI}/api/stations/${serial}/`,
      options = {
        method: 'DELETE',
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ loading: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => {

            this.setState((state, props) => {
              let prev_stations = Array.isArray(state.stations) ? state.stations.slice() : [];
              for (let i = 0; i < prev_stations.length; i++) {
                if (prev_stations[i].serial === serial) {
                  prev_stations.splice(i, 1);
                  return { stations: prev_stations, loading: false, viewStation: false };
                }
              }

              throw new Error('Deleted station not found.');

            });

          })
          .catch(error => console.log('Error:', error));

      });

  }

  handleStationDetailChange(event) {
    // Use only this function for ml_forcast, frost_monitoring and is_well_station state change 

    const value = event.target.value;

    if (event.target.name === 'is_well_station') {
      this.setState({
        viewedStation: {
          ...this.state.viewedStation,
          is_well_station: value,
        }
      });
      this.submit({ is_well_station: value });
      return
    }

    if (event.target.name === 'ml_forecast') {

      this.setState({
        viewedStation: {
          ...this.state.viewedStation,
          ml_forecast: value,
        }
      });
      this.submit({ ml_forecast: value });
    } else {
      this.setState({
        viewedStation: {
          ...this.state.viewedStation,
          frost_monitoring: value,
        }
      });
      this.submit({ frost_monitoring: value });
    }
  }

  submit(value) {
    let url = `${BASEURI}/api/stations/${this.state.viewedStation.serial}/`,
      options = {
        method: 'PUT',
        body: JSON.stringify({
          ...value
        }),
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => response.json())
          .then((stations) => {
            const normalizedStations = Array.isArray(stations) ? stations : [];
            this.setState({ renaming: false, stations: normalizedStations });
          })
          .catch(error => console.log('Error:', error));

      });
  }

  rename() {

    this.setState({ renaming: true });
    let url = `${BASEURI}/api/stations/${this.state.viewedStation.serial}/`,
      options = {
        method: 'PUT',
        body: JSON.stringify({
          name: this.state.viewedStation.name,
          plot: this.state.viewedStation.plot,
          crop: this.state.viewedStation.crop,
          details: { ...this.state.viewedStation.details }
        }),
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        }
      };

    getAuthToken()
      .then(token => token)
      .catch(handleAuthTokenError)
      .then(token => {
        if (token === false) {
          this.setState({ renaming: false });
          return false;
        }

        options.headers.Authorization = `Bearer  ${token}`;

        fetch(url, options)
          .then((response) => response.json())
          .then((stations) => {
            const normalizedStations = Array.isArray(stations) ? stations : [];
            this.setState({ renaming: false, stations: normalizedStations });
          })
          .catch(error => console.log('Error:', error));

      });
  }

  handleChange(event) {
    if (event.target.name === 'timezone') {
      this.setState({
        viewedStation: {
          ...this.state.viewedStation,
          details: {
            ...this.state.viewedStation.details,
            [event.target.name]: event.target.value
          }
        }
      });
    } else {
      this.setState({
        viewedStation: {
          ...this.state.viewedStation,
          [event.target.name]: event.target.value
        }
      });
    }

  }

  handleSearchInputChange(event) {
    this.setState({
      searchInput: event.target.value
    });
  }

  filterStations() {
    const stationsSource = Array.isArray(this.state.stations) ? this.state.stations : [];
    let stations = [];
    advancedFilter(
      this.state.searchInput,
      stationsSource,
      (items) => { stations = items },
      ['name', 'serial', 'api'])

    return stations
  }

  render() {
    let stations = this.filterStations().map((station) => {
      return (<StationCard intl={this.props.intl} key={station.serial} viewStation={this.viewStation} {...station} />);
    });

    return (

      <div className="mdl-grid ag-stations-grid">

        <div className='breadcrumb mdl-grid mdl-cell mdl-cell--12-col'>
          {this.props.intl.formatMessage({ id: 'app.stations.stations', defaultMessage: 'STATIONS' })}
        </div>
        <RefreshPortal>
          <RefreshButton onClick={this.refresh} loading={this.state.loading} />
        </RefreshPortal>
        <div className="mdl-cell mdl-cell--8-col" style={{ marginBottom: '30px' }}>
          <Input
            placeholder={this.props.intl.formatMessage({ id: 'app.stations.search', defaultMessage: 'Search' })}
            onChange={this.handleSearchInputChange}
            style={{ width: '100%' }}
            value={this.state.searchInput}
          />
        </div>
        {stations}

        <button onClick={this.openDialog} className="mdl-button mdl-js-button mdl-button--fab mdl-js-ripple-effect mdl-button--colored mdl-shadow--4dp mdl-color--primary ag-add-button">
          <i className="material-icons" role="presentation">add</i>
          <span className="visuallyhidden">Add</span>
        </button>
        <Modal>
          <ModalForm
            wiseconnStations={this.state.wiseconnStations}
            loadingDevices={this.state.loadingDevices}
            intl={this.props.intl}
            visible={this.state.showDialog}
            close={this.closeDialog}
            addStation={this.addStation}
            addDraginoStation={this.addDraginoStation}
            draginoModels={this.state.draginoModels}
            addDavisAccount={this.addDavisAccount}
            addQampoAccount={this.addQampoAccount}
            addWeenatAccount={this.addWeenatAccount}
            addPrismabAccount={this.addPrismabAccount}
            addAgroopAccount={this.addAgroopAccount}
            qampoAccounts={this.state.qampoAccounts}
            davisAccounts={this.state.davisAccounts}
            weenatAccounts={this.state.weenatAccounts}
            prismabAccounts={this.state.prismabAccounts}
            agroopAccounts={this.state.agroopAccounts}
            deleteDavisAccount={this.deleteDavisAccount}
            deleteQampoAccount={this.deleteQampoAccount}
            deleteWeenatAccount={this.deleteWeenatAccount}
            deletePrismabAccount={this.deletePrismabAccount}
            deleteAgroopAccount={this.deleteAgroopAccount}
            error={this.state.error}
            addingDevice={this.state.addingDevice}
          />
          <StationDetails
            tabs={this.props.tabs}
            visible={this.state.viewStation}
            close={() => this.setState({ viewStation: false, viewedStation: null, stationData: [] })}
            {...this.state.viewedStation}
            data={this.state.stationData}
            downloading={this.state.downloading}
            download={this.download}
            removeStation={this.removeStation}
            handleChange={this.handleChange}
            rename={this.rename}
            renaming={this.state.renaming}
            handleStationDetailChange={this.handleStationDetailChange}
            regenerateDraginoCredentials={this.regenerateDraginoCredentials}
            regenerating={this.state.regenerating}
            intl={this.props.intl}
          />
          <DraginoSetupDialog
            setup={this.state.draginoSetup}
            close={() => this.setState({ draginoSetup: null })}
            intl={this.props.intl}
          />
        </Modal>
      </div>

    );
  }
}

export default Stations;
